import * as React from "react";
import type { SVGProps } from "react";
const SvgBell = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M15.879 17.89h3.86a.99.99 0 0 0 .94-.73.956.956 0 0 0-.456-1.086 2.92 2.92 0 0 1-1.446-2.12v-2.892a7.73 7.73 0 0 0-3.945-6.398 2.92 2.92 0 0 0-2.84-2.289 2.92 2.92 0 0 0-2.844 2.29C6.82 5.96 5.328 8.366 5.203 11.101v2.851a2.92 2.92 0 0 1-1.445 2.121.96.96 0 0 0-.457 1.086c.117.43.504.73.941.73h3.88a3.878 3.878 0 1 0 7.757 0m-1.941 0A1.94 1.94 0 0 1 12 19.829a1.94 1.94 0 0 1-1.937-1.937Zm3.523-1.94a4.75 4.75 0 0 1-.602-1.825v-3.023c-.097-2.106-1.379-4.024-3.328-4.946a.97.97 0 0 1-.55-.875.974.974 0 0 0-.973-.968.974.974 0 0 0-.969.968c0 .38-.21.719-.55.875a5.83 5.83 0 0 0-3.329 4.985v2.976a4.9 4.9 0 0 1-.601 1.824l-.02.008Zm0 0"
      style={{
        stroke: "none",
        fillRule: "evenodd",
        fill: "#180f04",
        fillOpacity: 1,
      }}
    />
  </svg>
);
export default SvgBell;
